import { useState } from "react";
import { Filter } from "lucide-react";
import { ApiService } from "../../../services/api";
import { useModal } from "../../../hooks/useModal";

export default function AttendanceReportTab() {
  const { showAlert } = useModal();
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [status, setStatus] = useState<string>("all");
  const [attendanceStatus, setAttendanceStatus] = useState<string>("all");
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    if (!startDate || !endDate) {
      await showAlert({
        title: "Uyarı",
        message: "Lütfen başlangıç ve bitiş tarihlerini seçiniz.",
        type: "warning",
      });
      return;
    }

    try {
      setExporting(true);
      const blob = await ApiService.exportAttendanceReport({
        startDate,
        endDate,
        status: status === "all" ? undefined : status,
        attendanceStatus: attendanceStatus === "all" ? undefined : attendanceStatus,
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `yoklama-raporu-${new Date().toISOString().split("T")[0]}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      await showAlert({
        title: "Rapor İndirildi",
        message: "Yoklama raporu başarıyla indirildi.",
        type: "success",
      });
    } catch (error: any) {
      await showAlert({
        title: "Hata",
        message: error?.message || "Rapor indirilemedi. Lütfen tekrar deneyin.",
        type: "error",
      });
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="h-full flex flex-col">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
        <div className="flex items-center gap-3 mb-4">
          <Filter className="w-5 h-5 text-gray-600" />
          <h3 className="text-lg font-semibold text-gray-900">Filtreler</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="text-sm font-medium text-gray-700 mb-2 block">Başlangıç Tarihi</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700 mb-2 block">Bitiş Tarihi</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700 mb-2 block">Randevu Durumu</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option value="all">Tümü</option>
              <option value="APPROVED">Onaylandı</option>
              <option value="COMPLETED">Tamamlandı</option>
            </select>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700 mb-2 block">Yoklama Durumu</label>
            <select
              value={attendanceStatus}
              onChange={(e) => setAttendanceStatus(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option value="all">Tümü</option>
              <option value="ATTENDED">Katıldı</option>
              <option value="NO_SHOW">Katılmadı</option>
              <option value="UNMARKED">İşaretlenmedi</option>
            </select>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={handleExport}
            disabled={exporting || !startDate || !endDate}
            className={`px-6 py-2 rounded-lg font-medium text-sm transition-colors ${
              !startDate || !endDate || exporting
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700 text-white"
            }`}>
            Filtrele
          </button>
        </div>
      </div>
    </div>
  );
}
